$(document).ready(function () {
    if ($(".id--9").length) {
        $("tr.removeable").each(function () {
            if ($(this).find(".cart-p-image img").attr("data-src").includes("related")) {
                $(this).find(".cart-p-image img").attr("data-src", myImageSize($(this).find(".cart-p-image img").attr("data-src"), "big"));
            }
            $(this).find("td.p-availability .availability-label").appendTo($(this).find(".p-name"));

            if ($(window).width() < 992) {
                if ($(this).find(".myprice").length == 0) {
                    $("<div class='myprice'></div>").prependTo($(this).find(".p-total"));
                    $(this).find(".p-price > *").prependTo($(this).find(".p-total .myprice"));
                }
            }
        });

        $(".free-gifts-img img").each(function () {
            if ($(this).attr("data-src").includes("related")) {
                $(this).attr("data-src", myImageSize($(this).attr("data-src"), "big"));
            }
        });

        if ($(".discount-coupon").length) {
            $("#discountCouponCode").attr("placeholder", shopDataLayer.cart.coupon.placeholder);
            $(".discount-coupon button").html(shopDataLayer.cart.coupon.buttonText);
        }

        $(".next-step .next-step-forward").html(shopDataLayer.cart.nextStepButtons.firstStep);
        $(".cart-summary").prependTo(".sidebar-in-cart");
        $(".delivery-time").insertAfter(".extras-wrapper .extras-col:first-child");
    }

    if ($(".id--16").length) {
        $(".next-step #orderFormButton").html(shopDataLayer.cart.nextStepButtons.secondStep);
        $(".co-payment-method > h4.order-payment").html(shopDataLayer.cart.titles.payment);
        $(".co-delivery-method > h4.order-delivery").html(shopDataLayer.cart.titles.delivery);
        $(".cart-header").prependTo(".cart-inner");
    }

    if ($(".id--17").length) {
        $(".next-step #submit-order").html(shopDataLayer.cart.nextStepButtons.thirdStep);
        $(".co-contact-information > h4").html("<span>" + $(".co-contact-information > h4").text() + "</span>");
        $(".co-contact-information label[for='login']").next().find(".btn").html(shopDataLayer.cart.loginBtnText).appendTo(".co-contact-information > h4");
        $(".cart-header").prependTo(".cart-inner");
    }
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    if ($(".id--9").length) {
        $("tr.removeable").each(function () {
            if ($(this).find(".cart-p-image img").attr("src").includes("related")) {
                $(this).find(".cart-p-image img").attr("src", myImageSize($(this).find(".cart-p-image img").attr("data-src"), "big"));
            }
            $(this).find("td.p-availability .availability-label").appendTo($(this).find(".p-name"));

            if ($(window).width() < 992) {
                if ($(this).find(".myprice").length == 0) {
                    $("<div class='myprice'></div>").prependTo($(this).find(".p-total"));
                    $(this).find(".p-price > *").prependTo($(this).find(".p-total .myprice"));
                }
            }
        });

        $(".free-gifts-img img").each(function () {
            if ($(this).attr("data-src").includes("related")) {
                $(this).attr("data-src", myImageSize($(this).attr("data-src"), "big"));
            }
        });

        if ($(".discount-coupon").length) {
            $("#discountCouponCode").attr("placeholder", shopDataLayer.cart.coupon.placeholder);
            $(".discount-coupon button").html(shopDataLayer.cart.coupon.buttonText);
        }

        $(".next-step .next-step-forward").html(shopDataLayer.cart.nextStepButtons.firstStep);
        $(".cart-summary").prependTo(".sidebar-in-cart");
        $(".delivery-time").insertAfter(".extras-wrapper .extras-col:first-child");
    }
});